import { createSelector } from '@ngrx/store';

import { selectEligibleJointAccounts } from '../../client-accounts/client-accounts.selectors';
import { selectIsJointAccount } from '../../triage/triage.selectors';

export const selectInheritanceEligibility = createSelector(
  selectIsJointAccount,
  selectEligibleJointAccounts(),
  (
    isJointAccount: boolean,
    eligibleJointAccounts,
  ): { isEligible: boolean; isJointAccount: boolean; eligibleJointAccounts: any } => ({
    isEligible: isJointAccount ? eligibleJointAccounts.accounts.length > 0 : true,
    isJointAccount,
    eligibleJointAccounts: eligibleJointAccounts.accounts,
  }),
);
